module.exports = __webpack_public_path__ + "static/media/NF.d8432627.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/NF.svg
// module id = 2225
// module chunks = 7